export default __webpack_public_path__ + "static/media/messi_banner.64f0e000.png";